import { render, staticRenderFns } from "./funnel_chart_widget.vue?vue&type=template&id=64afdb1c&"
import script from "./funnel_chart_widget.vue?vue&type=script&lang=js&"
export * from "./funnel_chart_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports